import api from './api'

class UserMainService {
    // 获取主页数据
    static async getMainData() {
        const response = await api.get('/usermain/get_main_data/')
        return response.data
    }

    // 更新用户信息
    static async updateUserInfo(userData) {
        const response = await api.post('/usermain/update_user_info/', userData)
        return response.data
    }

    // 更新用户信息（包含文件上传）
    static async updateUserInfoWithAvatar(userData) {
        // 设置Content-Type为multipart/form-data，让浏览器自动设置boundary
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        const response = await api.post('/usermain/update_user_info/', userData, config)
        return response.data
    }

    // 获取所有应用
    static async getAllApps(userType) {
        const response = await api.post('/usermain/get_all_apps/', { usertype: userType })
        return response.data
    }

    // 为用户添加应用
    static async addAppForUser(appId) {
        const response = await api.post('/usermain/add_app_for_user/', {
            appid: appId
        })
        return response.data
    }

    // 添加链接
    static async addLink(linkData) {
        const response = await api.post('/usermain/add_link/', linkData)
        return response.data
    }

    // 删除链接
    static async deleteLink(graphId) {
        const response = await api.post('/usermain/delete_link/', { graphId })
        return response.data
    }
}

export default UserMainService